import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inputGroup" }
const _hoisted_2 = { class: "groupTitle" }
const _hoisted_3 = { class: "inputGroup" }
const _hoisted_4 = { class: "groupTitle" }
const _hoisted_5 = { class: "groupInputs flex" }
const _hoisted_6 = { class: "groupInputs flex" }
const _hoisted_7 = { class: "inputRow" }
const _hoisted_8 = { class: "flex flex-wrap" }
const _hoisted_9 = { class: "inputField flex-grow flex" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "inputTitle ml-2" }
const _hoisted_12 = { for: "isBusy" }
const _hoisted_13 = { class: "inputField flex-grow flex" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = { class: "inputTitle ml-2" }
const _hoisted_16 = { for: "isBusy" }
const _hoisted_17 = { class: "inputGroup" }
const _hoisted_18 = { class: "groupTitle" }
const _hoisted_19 = { class: "groupInputs flex" }
const _hoisted_20 = { class: "inputRow" }
const _hoisted_21 = { class: "flex flex-wrap" }
const _hoisted_22 = { class: "inputField flex-grow flex" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = { class: "inputTitle ml-2" }
const _hoisted_25 = { class: "inputField flex-grow flex" }
const _hoisted_26 = ["checked"]
const _hoisted_27 = { class: "inputTitle ml-2" }
const _hoisted_28 = { class: "inputGroup" }
const _hoisted_29 = { class: "groupTitle" }
const _hoisted_30 = { class: "inputGroup" }
const _hoisted_31 = { class: "groupTitle" }
const _hoisted_32 = { class: "inputGroup" }
const _hoisted_33 = { class: "groupTitle" }
const _hoisted_34 = { class: "inputGroup" }
const _hoisted_35 = { class: "groupTitle" }
const _hoisted_36 = { class: "groupInputs flex" }
const _hoisted_37 = { class: "groupInputs flex" }
const _hoisted_38 = { class: "inputRow" }
const _hoisted_39 = { class: "flex flex-wrap" }
const _hoisted_40 = ["checked", "id", "value"]
const _hoisted_41 = { class: "inputTitle ml-2" }
const _hoisted_42 = ["for"]
const _hoisted_43 = { class: "inputGroup" }
const _hoisted_44 = { class: "groupTitle" }
const _hoisted_45 = { class: "inputGroup" }
const _hoisted_46 = { class: "groupTitle" }

import FilterService from "@/utilities/services/FilterService";
import { TableType, ErrorLocationType } from "@/utilities/enums/Enums";
import { ref, computed, onMounted } from "vue";
import { useGlobalStore } from "@/stores/GlobalStore";
import {UserService} from "@/utilities/services/entities/UserService";
import {SelectableRoleInfo} from "@/models/SelectableRoleInfo";



export default /*#__PURE__*/_defineComponent({
  __name: 'UserFilterPopup',
  setup(__props) {

const globalStore = useGlobalStore();
const userService = new UserService();

const userFilters = computed(()=>{
  return globalStore.userPreferences.userFilters;
});
const userHiddenColumns = computed(()=>{
  return globalStore.userPreferences.userHiddenColumns;
});


const tmpUserFilters = computed(()=>{
  return globalStore.tmpPreferences.tmpUserFilters;
});
const tmpUserHiddenColumns = computed(()=>{
  return globalStore.tmpPreferences.tmpUserHiddenColumns;
});

const roleList = ref<Array<SelectableRoleInfo>>([]);

onMounted(async ()=>{
  //init tmp values
  globalStore.setTmpFilters(userFilters.value.filter(f => f.tableName === TableType[TableType.user]));
  globalStore.setTmpHiddenColumns(userHiddenColumns.value.filter(f => f.tableName === TableType[TableType.user]));

  // init afterFilters count
  globalStore.setCountAfterFilters(globalStore.gridStore?.count);

  roleList.value = await userService.getUserRoles(ErrorLocationType.popup) ?? [];
});



// init checkboxes according to tmpFilters [attributeValue == input-id]
const isFiltered = (attName, attVal) => {
  return tmpUserFilters.value.some(tuf => tuf.attributeName === attName && tuf.attributeValue === attVal.toString());
};

// init visibility buttons according to tmpHiddenColumns
const isHidden = (attName) => {
  return tmpUserHiddenColumns.value.some(thc => thc.attributeName === attName.toString());
};

const filterChanged = ({ target }, propName) => {
  if(target.checked) {
    // add to tmpFilterList
    globalStore.addUserFilter({tableName: TableType[TableType.user], attributeName: propName, attributeValue: target.value.toString()});
  }
  else {
    // remove from tmpFilterList
    tmpUserFilters.value.forEach((tuf,index)=>{
      if(tuf.attributeName === propName && tuf.attributeValue === target.value.toString()) tmpUserFilters.value.splice(index, 1);
    });

    globalStore.setTmpFilters(tmpUserFilters.value);
  }

  calculateRestEntities();
};


const visibilityChange = (colName) => {
  if(!tmpUserHiddenColumns.value.some(thc => thc.attributeName === colName)) {
    // add to tmpHiddenColumnList
    globalStore.addUserHiddenColumn({ tableName: TableType[TableType.user], attributeName: colName, attributeValue: "" });
  }
  else {
    // remove from tmpHiddenColumnList
    tmpUserHiddenColumns.value.forEach((thc,index)=>{
      if(thc.attributeName === colName) tmpUserHiddenColumns.value.splice(index, 1);
    });

    globalStore.setTmpHiddenColumns(tmpUserHiddenColumns.value);
  }

  calculateRestEntities();
};


const calculateRestEntities = () => {
  const allRecords = globalStore.gridStore.storage.allValues;
  const tmpFilterMethod = FilterService.buildFilter(TableType[TableType.user], true);

  let counter = 0;

  allRecords.forEach(r => {
    if (tmpFilterMethod(r)) counter++;
  });

  globalStore.setCountAfterFilters(counter);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userFilter.identificationNumber')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('identificationNumber') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visibilityChange('identificationNumber')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userFilter.groudKid')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('kid') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (visibilityChange('kid')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", {
                  checked: isFiltered('kid', 'true'),
                  type: "checkbox",
                  id: "hasKIDYes",
                  value: "true",
                  onChange: _cache[2] || (_cache[2] = (e) => filterChanged(e, 'kid'))
                }, null, 40, _hoisted_10),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('popups.userFilter.yes')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("input", {
                  checked: isFiltered('kid', 'false'),
                  type: "checkbox",
                  id: "hasKIDNo",
                  value: "false",
                  onChange: _cache[3] || (_cache[3] = (e) => filterChanged(e, 'kid'))
                }, null, 40, _hoisted_14),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('popups.userFilter.no')), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userFilter.groupActivitystatus')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('isActive') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (visibilityChange('isActive')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("input", {
                checked: isFiltered('isActive', 'true'),
                type: "checkbox",
                id: "isActiveYes",
                value: "true",
                onChange: _cache[5] || (_cache[5] = (e) => filterChanged(e, 'isActive'))
              }, null, 40, _hoisted_23),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('popups.userFilter.active')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("input", {
                checked: isFiltered('isActive', 'false'),
                type: "checkbox",
                id: "isActiveNo",
                value: "false",
                onChange: _cache[6] || (_cache[6] = (e) => filterChanged(e, 'isActive'))
              }, null, 40, _hoisted_26),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('popups.userFilter.inactive')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userEditor.firstName')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('firstName') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (visibilityChange('firstName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userEditor.lastName')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('lastName') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (visibilityChange('lastName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userEditor.info')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('info') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (visibilityChange('info')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userEditor.roles')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('roles') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (visibilityChange('roles')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (role) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "inputField flex w-1/3",
                  key: role
                }, [
                  _createElementVNode("input", {
                    checked: isFiltered('roles', role.name),
                    type: "checkbox",
                    id: 'role' + role.id.toString(),
                    value: role.name,
                    onChange: _cache[11] || (_cache[11] = (e) => filterChanged(e, 'roles'))
                  }, null, 40, _hoisted_40),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", {
                      for: 'role' + role.id.toString()
                    }, _toDisplayString(role.name), 9, _hoisted_42)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userEditor.phoneNumber')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('phoneNumber') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (visibilityChange('phoneNumber')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.userEditor.email')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('email') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[13] || (_cache[13] = ($event: any) => (visibilityChange('email')))
        }, null, 2)
      ])
    ])
  ]))
}
}

})